import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Spinner } from '@fluentui/react/lib/Spinner';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useReportDataSource } from '@bingads-webui-campaign/reports-v4-data-source';
import { TextField } from '@fluentui/react/lib/TextField';
import { Callout, mergeStyleSets } from '@fluentui/react';
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { isReportTemplateType } from '../shared';

const styles = mergeStyleSets({
  callout: {
    padding: '24px 16px',
    background: '#fff',
  },
  name: {
    marginBottom: 16,
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  spinner: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: '3',
    background: 'rgba(255, 255, 255, .6)',
  },
});

function InlineEditName(props) {
  const {
    target, item, onDismiss, onActionSuccess, notifyErrorPipe,
  } = props;
  const [name, setName] = useState(item.Name);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const i18n = useContext(I18nContext);
  const reportApi = useReportDataSource();
  const isReportTemplate = isReportTemplateType(item.Type);

  useEffect(() => {
    if (name.trim() === '') {
      setError(i18n.getString(_TL_('Required field')));
      return;
    }
    if (name.length > 85) {
      setError(i18n.getString(_TL_('Field should not exceed 85 characters')));
      return;
    }
    setError('');
  }, [i18n, name]);

  async function saveName() {
    if (error) {
      return;
    }
    if (name === item.Name) {
      onDismiss();
      return;
    }
    setLoading(true);
    try {
      const originTaskItem = await reportApi.getTaskItem(item.Id);
      const taskItemToSave = {
        ...originTaskItem,
        Name: name,
      };
      await reportApi.saveReport(taskItemToSave, { isEmailRule: !isReportTemplate });
      onDismiss();
      onActionSuccess();
    } catch (e) {
      notifyErrorPipe(e);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Callout
      coverTarget
      setInitialFocus
      doNotLayer
      preventDismissOnScroll
      directionalHint={0}
      isBeakVisible={false}
      onDismiss={onDismiss}
      target={target}
      className={`${styles.callout} inline-edit-popup`}
    >
      <TextField className={styles.name} defaultValue={item.Name} errorMessage={error} onChange={(e, v) => setName(v)} />
      <div className={styles.actions}>
        <PrimaryButton onClick={saveName} text={i18n.getString(_TL_('Save'))} />
        <DefaultButton onClick={onDismiss} text={i18n.getString(_TL_('Cancel'))} />
      </div>
      {loading && <Spinner className={styles.spinner} label={i18n.getString(_TL_('Loading...'))} labelPosition="right" />}
    </Callout>
  );
}

InlineEditName.propTypes = {
  item: PropTypes.shape({}).isRequired,
  target: PropTypes.shape({}).isRequired,
  onDismiss: PropTypes.func.isRequired,
  onActionSuccess: PropTypes.func.isRequired,
  notifyErrorPipe: PropTypes.func.isRequired,
};

export default InlineEditName;
